import styled from 'styled-components';

import StyledNote from '../ui/Note/Note.style';

export default styled(StyledNote)`
  background-color: ${({ theme }) => theme.COLOR_WHITE};
  color: ${({ theme }) => theme.COLOR_TEXT_PRIMARY};
  margin-bottom: 1.5rem;
`;
